import React from 'react';
import {
  HoverableCardsSectionItemBrandContainer,
  HoverableCardsSectionItemsBlock,
  HoverableCardsSectionItemsContainer,
  HoverableCardsSectionItemsDesktopContent,
  HoverableCardsSectionItemsMobileContent,
} from './HoverableCardsSectionItems.styles';
import { GatsbyImage } from 'gatsby-plugin-image';
import TextureOverlay from 'src/molecules/Standard/Shared/TextureOverlay/TextureOverlay';
import { IHoverableCardsSectionItem } from 'src/organisms/Shared/HoverableCardsSection/useHoverableCardsSection';
import Paragraph from 'src/elements/typography/paragraph';

interface HoverableCardsSectionItemsProps {
  active: boolean;
  items: IHoverableCardsSectionItem[];
}

const HoverableCardsSectionItems = ({ active, items }: HoverableCardsSectionItemsProps): JSX.Element => {
  const mobileItems = items.slice(0, 2);
  const renderItems = (items: IHoverableCardsSectionItem[]) => {
    return items.map((item) => (
      <HoverableCardsSectionItemsBlock
        background={item.backgroundColor}
        key={item.text}
      >
        <GatsbyImage
          image={item.avatarImage.gatsbyImageData}
          alt={item.text}
        />
        <TextureOverlay opacity={0.24} />
        <HoverableCardsSectionItemBrandContainer>
          <GatsbyImage
            image={item.logoImage.gatsbyImageData}
            alt={item.text}
            className='brand-image'
          />
          <Paragraph
            text={item.text}
            color='white'
            align='center'
            standardSize='1.5'
            className='brand-text'
          />
        </HoverableCardsSectionItemBrandContainer>
      </HoverableCardsSectionItemsBlock>
    ));
  };
  return (
    <HoverableCardsSectionItemsContainer
      active={active}
      className={`item-container`}
    >
      <HoverableCardsSectionItemsDesktopContent>{renderItems(items)}</HoverableCardsSectionItemsDesktopContent>
      <HoverableCardsSectionItemsMobileContent>{renderItems(mobileItems)}</HoverableCardsSectionItemsMobileContent>
    </HoverableCardsSectionItemsContainer>
  );
};

export default HoverableCardsSectionItems;
